import React, { useEffect, useState, createRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { firestore } from "../firebaseConfig";
import concepts from "../data/conceptList";
import {
  trays, chairs, neons, sunumluklar, columns,
  sehpalar, mumluklar, shamdanlar, benchler,
  vazolar, pastastandlari,
} from "../data/itemsList";

import PdfPreviewModal from "../components/PdfPreviewModal";
import ConceptSelectorModal from "./ConceptSelectorModal";
import MaterialListModal from "./MaterialListModal";
import PerdeTagModal from "../components/PerdeTagModal";
import GeriButonu from "../components/GeriButonu";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";

const allMaterials = [
  ...trays, ...chairs, ...neons, ...sunumluklar,
  ...columns, ...sehpalar, ...mumluklar, ...shamdanlar,
  ...benchler, ...vazolar, ...pastastandlari
];

function EventDetail() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPerdeModal, setShowPerdeModal] = useState(false);
  const [showMaterialModal, setShowMaterialModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [showConceptModal, setShowConceptModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);

  const [editPhone, setEditPhone] = useState(false);
  const [editDate, setEditDate] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [editNotes, setEditNotes] = useState(false);

  const navigate = useNavigate();
  const pdfRef = createRef();

  const conceptImages = concepts.reduce((acc, curr) => {
    acc[curr.name.toLowerCase()] = curr.image;
    return acc;
  }, {});

  useEffect(() => {
    const fetchEvent = async () => {
      const docRef = doc(firestore, "reservations", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setEvent(docSnap.data());
        setSelectedStatus(docSnap.data().status);
      }
    };
    fetchEvent();
  }, [id]);

  const handleUpdateField = async (field, value) => {
    const docRef = doc(firestore, "reservations", id);
    await updateDoc(docRef, { [field]: value });
    setEvent((prev) => ({ ...prev, [field]: value }));
  };

  const handleStatusChange = async () => {
    if (!event) return;
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const newStatusHistory = [
      ...(event.statusHistory || []),
      {
        changedBy: currentUser.email,
        timestamp: new Date().toISOString(),
        newStatus: selectedStatus,
      },
    ];

    try {
      const docRef = doc(firestore, "reservations", id);
      await updateDoc(docRef, {
        status: selectedStatus,
        statusHistory: newStatusHistory,
      });

      setEvent((prev) => ({
        ...prev,
        status: selectedStatus,
        statusHistory: newStatusHistory,
      }));
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 2000);
    } catch (error) {
      setShowError(true);
      setTimeout(() => setShowError(false), 2000);
    }
  };

  const handleStatusModalSelect = (status) => {
    setSelectedStatus(status);
    setShowStatusModal(false);
  };

  const getMaterialImage = (name) => {
    const match = allMaterials.find((item) => item.name === name);
    return match?.image || null;
  };

  if (!event) return <div>Yükleniyor...</div>;

  return (
    <div style={{ padding: "20px 40px", maxWidth: "1000px", margin: "0 auto", textAlign: "left" }}>
      <h2 style={{ marginBottom: "20px" }}>{event.customerName} - Organizasyon Detayı</h2>

      {event.selectedConcept && conceptImages[event.selectedConcept.toLowerCase()] && (
        <img
          src={conceptImages[event.selectedConcept.toLowerCase()]}
          alt={event.selectedConcept}
          style={{
            width: "100%", maxWidth: "600px", marginBottom: "20px", borderRadius: "10px"
          }}
        />
      )}

      {/* Telefon */}
      <p><strong>Telefon:</strong>{" "}
        {editPhone ? (
          <>
            <input
              value={event.phoneNumber}
              onChange={(e) => setEvent((prev) => ({ ...prev, phoneNumber: e.target.value }))}
            />
            <button onClick={() => {
              handleUpdateField("phoneNumber", event.phoneNumber);
              setEditPhone(false);
            }}>Kaydet</button>
            <button onClick={() => setEditPhone(false)}>İptal</button>
          </>
        ) : (
          <>
            {event.phoneNumber}{" "}
            <button onClick={() => setEditPhone(true)}>Düzenle</button>
          </>
        )}
      </p>

      {/* Tarih */}
      <p><strong>Tarih:</strong>{" "}
        {editDate ? (
          <>
            <input
              type="date"
              value={event.eventDate}
              onChange={(e) => setEvent((prev) => ({ ...prev, eventDate: e.target.value }))}
            />
            <button onClick={() => {
              handleUpdateField("eventDate", event.eventDate);
              setEditDate(false);
            }}>Kaydet</button>
            <button onClick={() => setEditDate(false)}>İptal</button>
          </>
        ) : (
          <>
            {event.eventDate}{" "}
            <button onClick={() => setEditDate(true)}>Düzenle</button>
          </>
        )}
      </p>

      {/* Konsept */}
      <p><strong>Konsept:</strong> {event.selectedConcept}{" "}
        <button onClick={() => setShowConceptModal(true)}>Düzenle</button>
      </p>

      {/* Adres */}
      <p><strong>Adres:</strong>{" "}
        {editAddress ? (
          <>
            <input
              value={event.address}
              onChange={(e) => setEvent((prev) => ({ ...prev, address: e.target.value }))}
            />
            <button onClick={() => {
              handleUpdateField("address", event.address);
              setEditAddress(false);
            }}>Kaydet</button>
            <button onClick={() => setEditAddress(false)}>İptal</button>
          </>
        ) : (
          <>
            {event.address || "—"}{" "}
            <button onClick={() => setEditAddress(true)}>Düzenle</button>
          </>
        )}
      </p>

      {/* Not */}
      <p><strong>Not:</strong>{" "}
        {editNotes ? (
          <>
            <input
              value={event.notes}
              onChange={(e) => setEvent((prev) => ({ ...prev, notes: e.target.value }))}
            />
            <button onClick={() => {
              handleUpdateField("notes", event.notes);
              setEditNotes(false);
            }}>Kaydet</button>
            <button onClick={() => setEditNotes(false)}>İptal</button>
          </>
        ) : (
          <>
            {event.notes || "—"}{" "}
            <button onClick={() => setEditNotes(true)}>Düzenle</button>
          </>
        )}
      </p>

      {/* Perde Tag */}
      {event.perdeTag !== undefined && (
        <div style={{ margin: "10px 0" }}>
          <span style={{
            backgroundColor: event.perdeTag ? "#10b981" : "#d36d6dff",
            color: "white",
            padding: "4px 10px",
            borderRadius: "9999px",
            fontWeight: "bold",
            fontSize: "14px",
            display: "inline-block"
          }}>
            {event.perdeTag ? "🎭 Perde Tag Var" : "🚫 Perde Tag Yok"}
          </span>
          <button onClick={() => setShowPerdeModal(true)} style={{ marginLeft: "10px" }}>
            Düzenle
          </button>
        </div>
      )}

      {/* Durum Geçmişi */}
      <h4>Durum Geçmişi:</h4>
      <ul>
        {(event.statusHistory || []).map((entry, index) => (
          <li key={index}>
            {new Date(entry.timestamp).toLocaleString("tr-TR")} — <strong>{entry.newStatus}</strong> olarak güncellendi ({entry.changedBy})
          </li>
        ))}
      </ul>

      {/* Kiralanan Malzemeler */}
      <h4>Kiralanan Malzemeler:</h4>
      <button onClick={() => setShowMaterialModal(true)}>
        Malzemeleri Düzenle
      </button>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginTop: "10px" }}>
        {(event.rentedItems || []).map((item, index) => {
          const name = typeof item === "string" ? item : item.name;
          const image = getMaterialImage(name);
          return (
            <div
              key={index}
              onClick={() => image && setModalImage(image)}
              style={{
                cursor: image ? "pointer" : "default",
                border: "1px solid #ccc",
                borderRadius: "10px",
                padding: "10px",
                background: "#ecfdf5",
                textAlign: "center",
                width: "150px",
              }}
            >
              {image && (
                <img
                  src={image}
                  alt={name}
                  style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "6px" }}
                />
              )}
              <div style={{ marginTop: "8px", fontSize: "14px" }}>{name}</div>
            </div>
          );
        })}
      </div>

      {/* Durum alanı */}
      <div style={{ marginTop: "30px" }}>
        <strong style={{ marginRight: "10px" }}>Durum:</strong>
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "20px",
            fontWeight: "bold",
            color: "white",
            backgroundColor:
              selectedStatus === "hazirlanacak" ? "orange" :
              selectedStatus === "kuruldu" ? "#4caf50" :
              selectedStatus === "toplandi" ? "#2196f3" :
              selectedStatus === "tamamlandi" ? "#9c27b0" : "#888"
          }}
        >
          {selectedStatus || "—"}
        </span>
        <button
          onClick={() => setShowStatusModal(true)}
          style={{
            marginLeft: "12px",
            backgroundColor: "#6754e2",
            color: "white",
            padding: "5px 12px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          Seç
        </button>
      </div>

      {/* Status modal */}
      {showStatusModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    }}
  >
    <div
      style={{
        background: "white",
        padding: "2rem",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        minWidth: "300px",
        textAlign: "center",
        boxShadow: "0 0 20px rgba(0,0,0,0.2)",
      }}
    >
      <h3 style={{ marginBottom: "10px", fontSize: "20px", color: "#111" }}>Durum Seç</h3>

      <button
        onClick={() => handleStatusModalSelect("hazirlanacak")}
        style={{
          backgroundColor: "#fbbf24", // sarı
          border: "none",
          borderRadius: "6px",
          padding: "10px",
          fontWeight: "bold",
          color: "#111",
          cursor: "pointer",
        }}
      >
        hazırlanacak
      </button>

      <button
        onClick={() => handleStatusModalSelect("kuruldu")}
        style={{
          backgroundColor: "#34d399", // yeşil
          border: "none",
          borderRadius: "6px",
          padding: "10px",
          fontWeight: "bold",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        kuruldu
      </button>

      <button
        onClick={() => handleStatusModalSelect("toplandi")}
        style={{
          backgroundColor: "#3b82f6", // mavi
          border: "none",
          borderRadius: "6px",
          padding: "10px",
          fontWeight: "bold",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        toplandi
      </button>

      <button
        onClick={() => handleStatusModalSelect("tamamlandi")}
        style={{
          backgroundColor: "#a855f7", // mor
          border: "none",
          borderRadius: "6px",
          padding: "10px",
          fontWeight: "bold",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        tamamlandi
      </button>

      <button
        onClick={() => setShowStatusModal(false)}
        style={{
          marginTop: "10px",
          backgroundColor: "#ef4444", // kırmızı
          color: "white",
          padding: "10px",
          border: "none",
          borderRadius: "6px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        İptal
      </button>
    </div>
  </div>
)}


      {/* Alt butonlar */}
      <div style={{ marginTop: "40px", display: "flex", gap: "12px" }}>
        <GeriButonu />
        <button
          onClick={handleStatusChange}
          style={{
            backgroundColor: "#10b981",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          Kaydet
        </button>
        <button
          onClick={() => setShowPdfModal(true)}
          style={{
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          PDF Oluştur
        </button>
      </div>

      {modalImage && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
          onClick={() => setModalImage(null)}
        >
          <img src={modalImage} alt="Malzeme" style={{ maxWidth: "90%", maxHeight: "90%" }} />
        </div>
      )}

      {showSuccess && <SuccessAlert message="Güncelleme başarılı!" />}
      {showError && <ErrorAlert message="Güncelleme başarısız!" />}

      <PdfPreviewModal
        isOpen={showPdfModal}
        onClose={() => setShowPdfModal(false)}
        pdfUrl={pdfUrl}
        onDownload={() => {
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = "organizasyon_formu.pdf";
          link.click();
        }}
      />

      <ConceptSelectorModal
        isOpen={showConceptModal}
        onClose={() => setShowConceptModal(false)}
        onSelect={(conceptName) => {
          handleUpdateField("selectedConcept", conceptName);
          setShowConceptModal(false);
        }}
      />

      <PerdeTagModal
        isOpen={showPerdeModal}
        onClose={() => setShowPerdeModal(false)}
        onSelect={(value) => {
          handleUpdateField("perdeTag", value);
          setShowPerdeModal(false);
        }}
      />

      <MaterialListModal
        isOpen={showMaterialModal}
        onClose={() => setShowMaterialModal(false)}
        defaultItems={(event.rentedItems || []).map((item) => ({
          name: typeof item === "string" ? item : item.name,
          checked: true
        }))}
        onConfirm={(selected) => {
          const updatedItems = selected.filter((i) => i.checked).map((i) => i.name);
          handleUpdateField("rentedItems", updatedItems);
          setShowMaterialModal(false);
        }}
      />
    </div>
  );
}

export default EventDetail;
